<div class="dialog">
  <div
    mat-dialog-title
    class="title"
  >
    {{ title }}
  </div>

  <div
    mat-dialog-content
    class="message"
  >
    <p>
      {{ message }}
    </p>
  </div>

  <div
    mat-dialog-content
    class="message"
  >
    <ng-container *ngFor="let row of messageList">{{ row }} <br /></ng-container>
  </div>

  <div
    mat-dialog-actions
    class="action-buttons"
  >
    <button
      mat-raised-button
      (click)="onClose()"
      class="dismiss"
    >
      OK
    </button>
  </div>
</div>
